import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  select: {
    width: '100%',
    minHeight: '50px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
});

const renderJoinItems = files => _.map(files, file => (
  <MenuItem key={file.id} value={file.id}>
    <ListItemText primary={file.filename} />
  </MenuItem>
));

const DialogFileName = ({
  onChange,
  name,
  shownName,
  filteredFiles,
  files,
  value,
  classes,
}) => {
  return (
  <FormControl fullWidth >
    <InputLabel htmlFor={`select-${name}`}>{shownName}</InputLabel>
    <Select
      inputProps={{
        name,
      }}
      value={value}
      input={<Input id={`select-${name}`} />}
      onChange={onChange}
      className={classes.select}
      renderValue={selected => (
        <div className={classes.chips}>
          <Chip key={selected} label={files[value].filename} className={classes.chip} />
        </div>
      )}
    >
      {renderJoinItems(filteredFiles || files)}
    </Select>
  </FormControl>
)};

DialogFileName.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  name: PropTypes.string.isRequired,
  shownName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  filteredFiles: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
  }),
  files: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
  }).isRequired,
  value: PropTypes.string,
  /* eslint-enable */
};

DialogFileName.defaultProps = {
  value: undefined,
  filteredFiles: undefined,
};

export default withStyles(styles)(DialogFileName);
